import * as Converter from "./converter";

import type * as Type from "./type";
import type * as Repository from "../repository";

type Props = {
	queryData: Repository.Query.Type.MagazineTagQueryData;
	viewModel: Type.ViewModel;
};

export const useViewData = ({ queryData, viewModel }: Props) => {
	const { viewData } = Converter.useViewDataConverter({ queryData, viewModel });

	return {
		viewData,
	};
};
